import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { SERVIDOR } from '../config';

const SecurePDFViewer = () => {
  const pdfUrl = 'https://firebasestorage.googleapis.com/v0/b/c-and-f.appspot.com/o/2020_SW_Profile_guide_8-13-21_speads.pdf?alt=media&token=6f3d1338-97d3-4a22-9bae-09a5512b54ef';
  const containerRef = useRef(null);
  const [hasValidated, setHasValidated] = useState(false);

  const validarAccesso = async () => {
    if (hasValidated) return; // Evita validaciones múltiples
    
    try {
      const token = localStorage.getItem('accesToken');
      const response = await axios.post(SERVIDOR + '/api/validar-acceso', { accesToken: token });
      const data = response.data;

      if (!data.ok) {
        alert('Acceso denegado');
        window.location.href = '/login';
      }
      setHasValidated(true);
    } catch (error) {
      console.error('Error al validar acceso:', error);
      window.location.href = '/login';
    }
  };

  const preventRightClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const preventTouchActions = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // Efecto único para validación de acceso
  useEffect(() => {
    validarAccesso();
  }, []); // Solo se ejecuta una vez al montar el componente

  // Efecto separado para la configuración de seguridad
  useEffect(() => {
    const container = containerRef.current;

    const handleKeyDown = (e) => {
      const restrictedShortcuts = [
        (e.ctrlKey && e.key === 's'),
        (e.ctrlKey && e.key === 'p'),
        (e.ctrlKey && e.key === 'c'),
        (e.ctrlKey && e.key === 'v'),
        (e.key === 'PrintScreen'),
        (e.ctrlKey && e.key === 'a')
      ];

      if (restrictedShortcuts.some(Boolean)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    if (container) {
      container.oncontextmenu = preventRightClick;
      document.body.oncontextmenu = preventRightClick;
      container.addEventListener('keydown', handleKeyDown);
      container.addEventListener('touchstart', preventTouchActions);
      container.addEventListener('touchmove', preventTouchActions);
      container.addEventListener('touchend', preventTouchActions);
    }

    const disableSelection = (e) => {
      e.preventDefault();
    };

    if (container) {
      container.addEventListener('selectstart', disableSelection);
      container.style.userSelect = 'none';
      container.style.webkitUserSelect = 'none';
    }

    return () => {
      if (container) {
        container.oncontextmenu = null;
        document.body.oncontextmenu = null;
        container.removeEventListener('keydown', handleKeyDown);
        container.removeEventListener('touchstart', preventTouchActions);
        container.removeEventListener('touchmove', preventTouchActions);
        container.removeEventListener('touchend', preventTouchActions);
        container.removeEventListener('selectstart', disableSelection);
      }
    };
  }, []); // Solo se ejecuta una vez al montar el componente

  if (!hasValidated) {
    return <div className="flex items-center justify-center h-screen">Validando acceso...</div>;
  }

  return (
    <div 
      ref={containerRef}
      className="relative w-full h-screen"
      onContextMenu={preventRightClick}
      onTouchStart={preventTouchActions}
      onTouchMove={preventTouchActions}
      onTouchEnd={preventTouchActions}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full h-full relative">
          <div 
            className="absolute inset-0 overflow-auto"
            style={{
              pointerEvents: 'auto',
              userSelect: 'none',
              webkitUserSelect: 'none'
            }}
          >
            <iframe
              src={`${pdfUrl}#toolbar=0&navpanes=0`}
              className="w-full h-full"
              style={{
                border: 'none',
                pointerEvents: 'auto',
                userSelect: 'none',
                webkitUserSelect: 'none'
              }}
              title="PDF Scrollable"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurePDFViewer;